import React from 'react'

import { useLegendData } from '../hooks'
import LegendItem from './LegendItem'

interface LegendProps {

}

const Legend: React.FC<LegendProps> = () => {
  const data = useLegendData()
  if (!data || !data.layers) return null

  return (
    <div>
      {data.layers.map((layer, index) => {
        return <LegendItem key={index} data={layer} />
      })}
    </div>
  )
}

export default Legend